// Speed: videos printed with data-lazy-video (snippets/lazy-video.liquid) get their file only when they come near the
// screen and are actually shown (a desktop/mobile pair downloads one video, not both). Autoplay, loop and the other
// attributes are untouched, so the video plays exactly as before once its file is there.
(() => {
  if (window.themeLazyVideo) return; // the theme editor can run this file again
  window.themeLazyVideo = true;
  const load = (video) => {
    video.querySelectorAll('source[data-lazy-src]').forEach((source) => { source.src = source.dataset.lazySrc; source.removeAttribute('data-lazy-src'); });
    video.removeAttribute('data-lazy-video');
    video.load();
  };
  const shown = (video) => video.getClientRects().length > 0;
  if (!('IntersectionObserver' in window)) {
    const all = () => document.querySelectorAll('video[data-lazy-video]').forEach((video) => shown(video) && load(video));
    all();
    window.addEventListener('resize', all);
    return;
  }
  // near = within one screen height above/below, and one screen width to the sides (slides waiting in a carousel)
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting || !shown(entry.target)) return;
      observer.unobserve(entry.target);
      load(entry.target);
    });
  }, { rootMargin: '100% 100%' });
  const watch = (root = document) => root.querySelectorAll('video[data-lazy-video]').forEach((video) => observer.observe(video));
  watch();
  // a hidden copy (e.g. the mobile video on desktop) is checked again when the screen size changes
  window.addEventListener('resize', () => document.querySelectorAll('video[data-lazy-video]').forEach((video) => { observer.unobserve(video); observer.observe(video); }));
  document.addEventListener('shopify:section:load', (event) => watch(event.target));
  // Theme editor: a re-rendered section leaves; stop watching its old videos.
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll?.('video[data-lazy-video]').forEach((video) => observer.unobserve(video)));
})();
